<template>

  <div class="workshops-bespoke">

    <nav-1></nav-1>

    <hero :image="hero"></hero>

    <div class="content-text">
      <h1>Workshop Strategy & Partnership</h1>
      <h4 class="size__content__default pos__content__center" xxxxxcontenteditable>
        Beyond learning, workshops can serve as a powerful tool for brands and institutions to foster meaningful relationships with their customers. <!--In an increasingly media saturated world, consumers are placing greater importance on physical experiences and interacting face-to-face with brands over traditional marketing.--> Discover how our workshops can facilitate your event, exhibition programme or product launch to connect with your audience on a more engaging level. Whether it’s creating a cookbook via a workshop app, branding a festival or co-creating artworks with 400 children, we offer a full workshop strategy for:
      </h4>
      <div class="strategy-list size__content__default pos__content__center">
        <ul class="">
          <li><h4>Exhibition programmes</h4></li>
          <li><h4>Education projects</h4></li>
          <li><h4>Experiential installations</h4></li>
          <li><h4>Brand activation</h4></li>
          <li><h4>Product launch experiences</h4></li>
          <li><h4>Events and festivals</h4></li>
          <li><h4>Community programmes</h4></li>
        </ul>
      </div>
    </div>


    <!-- <gooey></gooey>     -->
    <div class="carousel-wrapper">
      <h4 class="size__content__default pos__content__center">
        We have worked with clients across the art, commercial and education sectors and partnered with curators, brands and experts from other fields.
      </h4>
      <flickity class="carousel" ref="flickity" :options="flickityOptions">
        <div class="carousel-cell" v-for="(cell, index) in carousel">
          <div class="carousel-media" :style="{'backgroundImage': 'url(' + cell.image + ')', 'backgroundPosition': index === 2 ? 'top center' : 'bottom center'}" ></div>
          <div class="carousel-text" ><h4>{{cell.text}}</h4></div>
        </div>
      </flickity>
    </div>


    <!--  -->

    <div class="quotes size__content__wide pos__content__center">
      <div class="quote">
        <h4>“Hato led a risograph workshop for our partnership with The Conran Shop during LDF, we really enjoyed working with Hato on this project. They're super efficient, provided innovative concepts and a pleasure to work&nbsp;with!”</h4>
        <p>Manda Wilks, Project Manager, It's&nbsp;Nice&nbsp;That</p>
      </div>
      <div class="quote">
        <!-- <h3>Hato’s energy and enthusiasm [...] led to an imaginative and fun day for families at the RA.</h3> -->
        <h4>“Hato’s energy and enthusiasm for playing with printing led to an imaginative and fun day for families at the RA. Families colourfully reimagined abstract works guided by the Hato team which allowed parents and children to create in an exploratory way discovering new printing&nbsp;skills”</h4>
        <p>Gwen Ramsay, Family Programmer, Royal&nbsp;Academy&nbsp;of&nbsp;Arts.</p>
      </div>
      <!-- <div class="quote">
        <h3>“Our creative team loved the chance to roll up our sleeves and learn risoprinting from one of the finest studios in London. The session was well run. Hats off to Hato.”</h3>
        <p>Shirley, Senior Copywriter, Virgin Media.</p>
      </div> -->
    </div>

    <div class="content-logos">
      <img class="size__content__narrow" src="../assets/clients/strategy-logo-blocks-2.png" alt="">
    </div>



    <!-- <div class="grid">
      <div class="item" v-for="p in carousel" >
        <div class="background" :style="{'backgroundImage': 'url('+p.image+')'}">

        </div>
      </div>
    </div> -->



    <div class="clients-wrapper">
      <h4 class="size__content__narrow pos__content__center">
        We have worked with clients across the art, commercial and education sectors and partnered with curators, brands, educators and experts from other fields.
      </h4>
      <div class="clients layout-b xxxlayout-a">
        <div>
          <h3>It’s Nice That</h3>
          <p>Strategy<br>Brand Partnership</p>
        </div>
        <div>
          <h3>Pick Me Up</h3>
          <p>Festival Activation<br>Strategy </p>
        </div>
        <div>
          <h3>Facebook</h3>
          <p>Strategy<br>Analog and Digital Engagement </p>
        </div>
        <div>
          <h3>Royal Academy</h3>
          <p>Strategy<br>Co-creation<br>Exhibition</p>
        </div>
        <div>
          <h3>Urban Outfitters</h3>
          <p>Brand Partnership<br>Strategy </p>
        </div>
        <div>
          <h3>Liverpool Biennial</h3>
          <p>Education<br>Community<br>Co-design<br>Digital Engagement</p>
        </div>
        <div>
          <h3>The V&A</h3>
          <p>Education</p>
        </div>
        <div>
          <h3>University of Arts London</h3>
          <p>Strategy</p>
        </div>
        <div>
          <h3>Edgware Road Project</h3>
          <p>Strategy<br>Co-creation<br>Exhibition</p>
        </div>
        <div>
          <h3>Tate Exchange</h3>
          <p>Education<br>Strategy<br>Publishing</p>
        </div>
        <div>
          <h3>British Council</h3>
          <p>Strategy<br>Co-creation<br>Exhibition</p>
        </div>
      </div>
    </div>


    <div class="action-wrapper">
      <div class="action">
        <h3>Get in touch to learn more about our bespoke workshops, or any general enquiries on workshops.</h3>
        <a href="mailto:bespoke@hatopress.net?subject=Strategy and Partnership">bespoke@hatopress.net</a>
        <a href="tel:+44-207-729-5585">+44 (0)207 729 5585</a>
      </div>
    </div>

  </div>

</template>

<script>

import Nav1 from '@/components/Nav1'
// import Gooey from '@/components/Gooey'
import Hero from '@/components/Hero'
import Flickity from '@/components/Flickity'

export default {
  ready: function () {
    let self = this
    window.addEventListener('resize', self.handleResize)
  },
  beforeDestroy: function () {
    let self = this
    window.addEventListener('resize', self.handleResize)
  },
  components: {
    Nav1,
    Flickity,
    // Gooey,
    Hero
  },
  data () {
    return {
      hero: require('../assets/workshops/hatopress-whitechapel.jpg'),
      carousel: [
        {
          image: require('../assets/workshops/hatopress-dandad.jpg'),
          text: 'D&AD New Blood Academy'
        },
        {
          image: require('../assets/workshops/hatopress-whitechapel.jpg'),
          text: 'Whitechapel Gallery'
        },
        {
          image: require('../assets/workshops/hatopress-workshops-archive-9.jpg'),
          text: 'It’s Nice That'
        },
        {
          image: require('../assets/workshops/hatopress-workshops-archive-10.jpg'),
          text: 'Royal Academy'
        },
        {
          image: require('../assets/workshops/hatopress-jj-underdogs-painting-1.jpg'),
          text: 'Jean Jullien book launch'
        },
        {
          image: require('../assets/workshops/liverpool.jpg'),
          text: 'Liverpool Biennial'
        },
        {
          image: require('../assets/workshops/hatopress-workshops-archive-4.jpg'),
          text: 'The V&A Museum of Childhood'
        },
        {
          image: require('../assets/workshops/hatopress-workshops-archive-6.jpg'),
          text: 'Whitechapel Gallery'
        },
        {
          image: require('../assets/workshops/hatopress-workshops-archive-1.jpg'),
          text: 'Serpentine Galleries'
        }
        // {
        //   image: require('../assets/workshops/hatopress-workshops-archive-8.jpg'),
        //   text: 'Tate Exchange'
        // },
        // {
        //   image: require('../assets/workshops/hatopress-workshops-archive-2.jpg'),
        //   text: 'British Council'
        // }
      ],
      flickityOptions: {
        // contain: true,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        setGallerySize: true
        // ,
        // autoPlay: 3000
      }
    }
  },
  mounted () {
    // this.initWaypoints()
    let self = this
    self.$refs.flickity.initFlickity()
    let flkty = self.$refs.flickity.flickity
    if (flkty) {
      flkty.on('staticClick', self.flkty_staticClick)
    }
  },
  methods: {
    flkty_staticClick: function (event, pointer, cellElement, cellIndex) {
      // console.log(event, pointer, cellElement, cellIndex)
      let self = this
      let flkty = self.$refs.flickity.flickity
      if (cellIndex >= flkty.selectedIndex) {
        // console.log('next')
        self.$refs.flickity.next()
      } else {
        // console.log('prev')
        self.$refs.flickity.previous()
      }
    },
    handleResize: function (event) {
      console.log('handleResize:', event)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.content-text {
  margin: auto;
  padding: 1rem 1rem 1rem;
  margin: 0rem auto 2rem;
  text-align: left;
  /*max-width: 1000px;*/
}

h2 {
  margin-top: 0;
  /*text-align: center;*/
}

.strategy-list {
  column-count: 2;
  margin-bottom: 1.5em;
  list-style-type: disc;
}
.strategy-list ul {
  margin-left: 1rem;
  list-style-type: inherit;
}
.strategy-list ul, .strategy-list li {
  list-style-type: inherit;
}
.strategy-list h4 {
  margin: 0;
}


.action-wrapper {
  background: #f0f0f0;
  padding: 1rem 0;
}

.action {
  padding: 2rem 0;
  margin: 0 auto;
  max-width: 600px;
  text-align: center;
}
.action a {
  display: inline-block;
  margin: 1rem .5rem;
  padding: .5em 1em;
  border-radius: 5px;
  /*border: 1px solid #000;*/
  background: hsl(158, 81%, 57%)
}
.action a:hover {
  background: hsl(158, 81%, 77%);
}





.clients-wrapper {
  display: none;
  background: #fafafa;
  padding: 3rem 0 0;
}
.clients.layout-a {
  max-width: 1000px;
  margin: 3rem auto 0rem;
  padding: 0 0 4rem;
  /*display: flex;
  flex-direction: column;*/
  column-count: 3;
}
.clients.layout-a div {
  text-align: center;
  /*width: 50%;*/
  break-inside: avoid;
  margin-bottom: 2rem;
}
.clients.layout-a h3 {
  margin-bottom: .25em;
}




.clients.layout-b {
  /*max-width: 1000px;*/
  margin: 3rem auto 0;
  /*display: flex;
  flex-direction: column;*/
  /*column-count: 3;*/
}
.clients.layout-b div {
  /*text-align: center;*/
  /*width: 50%;*/
  /*break-inside: avoid;*/
  position: relative;

  min-height: 20rem;
  padding: 2rem 67% 2rem 0rem;
  margin-bottom: 0rem;
  background: hsl(186, 81%, 57%);
}
.clients.layout-b div:nth-child(2n) {
  padding: 2rem 0rem 2rem 67%;
  background: hsl(186, 81%, 70%);
}
.clients.layout-b div:after {
  content: "";
  position: absolute;
  background: #ccc;
  top: 0;
  bottom: 0;
  left: 33%;
  right: 0;
}
.clients.layout-b div:nth-child(2n):after {
  content: "";
  position: absolute;
  background: #999;
  top: 0;
  bottom: 0;
  left: 0%;
  right: 33%;
}
.clients.layout-b h3 {
  margin-bottom: .25em;
}
.clients.layout-b h3,
.clients.layout-b p {
  padding-left: 2rem;
  padding-right: 2rem;
}



.carousel-wrapper {
  background: #f6f6f6;
  /*padding: 8rem 0 7rem;*/
  padding: 4rem 0 4rem;
  margin: 1rem 0 4rem;
  width: 100%;
  /*height: 500px;*/
  position: relative;
}

.carousel {
  /*position: absolute;*/
  /*top:0;*/
  /*left: 0;*/
  margin: 3rem 0 0 0;
  width: 100%;
  /*height: 100%;*/
}

.carousel-cell {
  width: 700px;
  height: 500px;
  margin: 0 5%;
}

.carousel-media {
  /*width: 700px;*/
  /*height: 500px;*/
  width: 100%;
  height: 0;
  padding-bottom: 65%;
  margin: 0 auto;
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
  pointer-events: none;
}
.carousel-text {
  margin: 1rem auto 0;
  text-align: center;
  pointer-events: none;
}

.content-logos {
  margin: 4rem auto 6rem;
}



.grid {
  display: flex;
  flex-wrap: wrap;
}
.grid .item {
  width: 33.33%;
  height: 0;
  padding-bottom: 25%;
  background: #ddd;
  position: relative;
}
.grid .item:nth-child(2n) {
  background: #eee;
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
  /*filter: saturate(1);
  /*mix-blend-mode: multiply;*/
  /*opacity: 0.9;*/
}



.quotes {
  /*max-width: 1000px;*/
  padding: 0rem 0 0rem;
  /*margin: auto;*/
  display: flex;
  justify-content: space-between;
}
.quote {
  /*max-width: 600px;*/
  width: 49%;
  padding: 2rem 2rem 1rem;
  margin: 1rem 0;
  border-radius: 5px;
  background: hsl(186, 81%, 57%);
}




@media screen and (max-width: 1024px) {
  .carousel-wrapper h4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .carousel-cell {
    width: 600px;
    height: 500px;
    margin: 0 50px;
  }
  .carousel-media {
    /*width: 600px;
    height: 400px;*/
  }
  .quotes {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .content-logos {
    margin-top: 1rem;
    margin-bottom: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
@media screen and (max-width: 768px) {
  .carousel-cell {
    width: 600px;
    height: 500px;
    margin: 0 50px;
  }
  .carousel-media {
    /*width: 600px;
    height: 400px;*/
  }
  .content-image {
    max-width: 400px;
  }
  .carousel-text {
    margin: 1rem auto 0;
  }
}
@media screen and (max-width: 640px) {
  .quotes {
    flex-direction: column;
  }
  .quote {
    width: 100%;
    margin-top: 0;
    margin-bottom: 1rem;
  }
  .carousel-cell {
    width: 80%;
    height: 75vw;;
    margin: 0 10px;
  }
  .content-text {
    margin-bottom: 1rem;
    padding-bottom: 0;
  }
  .carousel-wrapper {
    padding-top: 1rem;
    padding-bottom: 0;
    margin-bottom: 1rem;
  }
  .carousel {
    margin-top: 2rem;
  }
  .action a {
    margin: .5em 1em;
  }
}
</style>



// WEBPACK FOOTER //
// WorkshopsStrategy.vue?206dd494